import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ClerkService } from 'ngx-clerk-iliad';
import { map, take, catchError, of, firstValueFrom } from 'rxjs';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const clerkService = inject(ClerkService);

  try {
    // Wait for the first emission of user authentication status
    const isAuthenticated = await firstValueFrom(
      clerkService.user$.pipe(
        take(1),
        map(user => !!user),
        catchError(() => of(false))
      )
    );

    if (!isAuthenticated) {
      // If not authenticated, redirect to auth page immediately
      router.navigate(['/auth']);
      return false;
    }

    return true;
  } catch (error) {
    console.error('[AuthGuard] Error checking authentication:', error);
    router.navigate(['/auth']);
    return false;
  }
};
